module.exports = __webpack_public_path__ + "static/media/help-rule-2.2e6bf32c.gif";